<template>
  <div id="ResetPassword" class="container">
    <ResetPass :token="token" />
  </div>
</template>

<script>
import ResetPass from "../components/ResetPass";

export default {
  name: "resetpassword",
  data() {
    return {
      CorreoEnviado: false,
      urlActual: null,
      token: "",
    };
  },
  mounted() {
    // Validar la ruta al cargar ruta padre
    this.validarURL();
  },
  methods: {
    validarURL() {
      // verificar url
      this.urlActual = window.location;
      this.token = this.urlActual.href.split("token=")[1];
      console.info(this.token)
    },
  },
  components: {
    ResetPass,
  },
};
</script>

<style scoped>
#ResetPassword {
  padding: 10% 0;
}
</style>